import { TreePine, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  isAdmin: boolean;
  onAddFirstMember?: () => void;
}

export function EmptyState({ isAdmin, onAddFirstMember }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="text-center space-y-6">
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <TreePine className="h-8 w-8 text-primary" />
          </div>
          <h3 className="text-xl font-semibold text-gray-900">
            لا يوجد أفراد في شجرة العائلة
          </h3>
          <p className="text-gray-500 max-w-md">
            {isAdmin 
              ? 'قم بإضافة أول فرد في شجرة العائلة للبدء'
              : 'لا توجد بيانات متاحة حالياً'}
          </p>
        </div>

        {isAdmin && onAddFirstMember && (
          <Button 
            onClick={onAddFirstMember}
            className="hover:bg-secondary"
            size="lg"
          >
            <Plus className="h-5 w-5 ml-2" />
            إضافة أول فرد
          </Button>
        )}
      </div>
    </div>
  );
}